module.exports = __webpack_public_path__ + "img/noindividual.cb1e8fe8.svg";